

import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import BannerImg from "../assets/banner-img.png";
import OffImg from "../assets/off.png";
import { useTranslation } from "react-i18next";

const HomeBanner = () => {
  const { t, i18n } = useTranslation();
  return (
    <div className="banner-section mb-md-5 mb-4 mt-md-5 mt-4">
      <div className="container">
        <div className="banner-slider">
          {/* Swiper Slider replacing Owl */}
          <Swiper
            key={i18n.language}
            modules={[Navigation, Pagination, Autoplay]}
            loop={true}
            autoplay={false}
            navigation
            pagination={false}
            className="banner-slider-main"
            dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
          >
            {/* Slide 1 */}
            <SwiperSlide className="item">
              <div className="banner-slider-box">
                <div className="img-box">
                  <img src={BannerImg} alt="Banner 1" />
                </div>
                <div className="text-box">
                  <div className="banner-text-box">
                    <h1 className="d-flex flex-wrap align-items-center">
                      {t("Grab up to")}
                      <span>
                        <img src={OffImg} alt={t("Offer")}/>
                      </span>
                      {t("on your favorite Destination")}
                    </h1>
                    <p>{t("Limited time offer, don't miss the opportunity")}</p>
                    <a href="#" className="btn btn-primary btn-white">
                      {t("Book Now")}
                    </a>
                  </div>
                </div>
              </div>
            </SwiperSlide>

            {/* Slide 2 */}
            <SwiperSlide className="item">
              <div className="banner-slider-box">
                <div className="img-box">
                  <img src={BannerImg} alt="Banner 2" />
                </div>
                <div className="text-box">
                  <div className="banner-text-box">
                    <h1 className="d-flex flex-wrap align-items-center">
                      {t("Grab up to")}
                      <span>
                        <img src={OffImg} alt={t("Offer")}/>
                      </span>
                      {t("on your favorite Destination")}
                    </h1>
                    <p>{t("Limited time offer, don't miss the opportunity")}</p>
                    <a href="#" className="btn btn-primary btn-white">
                      {t("Book Now")}
                    </a>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default HomeBanner;